<div class="container margem-normal" [ngClass]="{
  'tamanho-1': config.tamanho.id == 1 || config.tamanho == 1, 
  'tamanho-2': config.tamanho.id == 2 || config.tamanho == 2, 
  'tamanho-3': config.tamanho.id == 3 || config.tamanho == 3, 
  'tamanho-4': config.tamanho.id == 4 || config.tamanho == 4,
  'margem': config.margem == 1 && config.tamanho != 4,
  }" [ngStyle]="{'background': getBackground(), 'border': getBorder(), 'color': getFontColor() }">
  <div class="centered" [ngClass]="{
    'negrito-1' : config.negrito == 1,
    'negrito-2' : config.negrito == 2,
    'negrito-3' : config.negrito == 3
  }">
    <div *ngIf="isIcone()">
      <i
        class="dynamic-icon {{getIcon()}}"
        [style.--icon-size]="getIconSize()"
        [style.--icon-color]="getFontColor()"
      ></i>

      <br>
    </div>

    <div *ngIf="!isIcone()">
      <img [ngStyle]="{'height': getIconSize()}" src="{{config.icon}}">
    </div>

    <span class="descricao"
      [ngStyle]="{'font-size': getFontSize(), 'font-weight': getFontWeight(), 'color': getFontColor()}">
      {{config.label}}

      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'MensagemPage' && mensagemProvider.getTotalMensagensNaoLidas() != 0"
        color="danger">
        {{mensagemProvider.getTotalMensagensNaoLidas()}}
      </ion-badge>

      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'OracaoPage' && oracaoProvider.getAdminTotal() != 0"
        color="danger">
        {{oracaoProvider.getAdminTotal()}}
      </ion-badge>

      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'NoticiaPage' && noticiaProvider.getTotalNaoLidas() != '0'"
        color="danger">
        {{noticiaProvider.getTotalNaoLidas()}}
      </ion-badge>

    </span>
  </div>
</div>